export default __webpack_public_path__ + "static/2242-9deb2f0ed778dfdd643c2a804048f433.gif";